/* RapidPlas add-to-cart redirect — Golden Panda / SF035
   With the mini-cart drawer disabled, the theme's Preact add-to-cart posts to
   /cart/add.js and then has nothing to open. This watches for a successful add
   and sends the shopper to the cart page, where the delivery check and the
   checkout / quote actions live.
   Only /cart/add is matched, so /cart/update.js (used by the delivery locator
   to store the suburb) and /cart.js reads are left alone. */
(function () {
  'use strict';

  var CART_ADD = /\/cart\/add(\.js)?(\?|$)/;
  var redirecting = false;

  function cartUrl() {
    return (window.rpCartUrl || '/cart');
  }

  function go() {
    if (redirecting) return;
    redirecting = true;
    window.location.href = cartUrl();
  }

  // fetch()
  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var promise = originalFetch.apply(this, arguments);
      if (CART_ADD.test(url)) {
        promise.then(function (res) {
          if (res && res.ok) setTimeout(go, 120);
        }).catch(function () { /* leave the page alone on failure */ });
      }
      return promise;
    };
  }

  // XMLHttpRequest
  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try { this.__rpCartAdd = CART_ADD.test(url || ''); } catch (e) { this.__rpCartAdd = false; }
    return originalOpen.apply(this, arguments);
  };

  var originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (xhr.__rpCartAdd) {
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) setTimeout(go, 120);
      });
    }
    return originalSend.apply(this, arguments);
  };
})();
